<div class="o-modal--alert o-modal--success o-modal--medium" id="mod-ap-req" style="width: 100%;">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalApprovePortal.title' | translate}}</label>
    </div>
    <div class="o-modal__body" style="padding-left: 40px;">
        <p> {{ 'ModalApprovePortal.body' | translate}}</p>
    </div>

    <div class="o-modal__footer">
        <div>
            <button mat-button mat-dialog-close class="btn btn--default" style="padding-left: 19px;"><u>{{ 'ModalApprovePortal.btnCancel' | translate}}</u></button>
            <button mat-button (click)="closeModalAccept()" class="btn btn--primary">{{ 'ModalApprovePortal.btnAccept' | translate}}</button>
        </div>
    </div>
</div>
<!-- modificacion -->